<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import { useLocale } from '@/composables/useLocale'

const { t } = useI18n()
const { currentLocale, supportedLocales, switchLocale } = useLocale()
</script>

<template>
  <div class="min-h-screen bg-slate-900 flex flex-col">
    <!-- Minimal public header -->
    <header class="border-b border-slate-800 bg-slate-900/80 backdrop-blur-sm sticky top-0 z-30">
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <div class="flex items-center justify-between h-14">
          <!-- Logo -->
          <RouterLink
            to="/"
            class="inline-flex items-center gap-2"
          >
            <span class="text-lg font-black text-white tracking-tight">Startline</span>
            <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 mb-0.5" />
          </RouterLink>

          <div class="flex items-center gap-3">
            <!-- Language selector -->
            <div class="flex items-center gap-1">
              <button
                v-for="locale in supportedLocales"
                :key="locale"
                type="button"
                class="text-xs px-2 py-1 rounded transition-colors uppercase"
                :class="currentLocale === locale
                  ? 'text-white font-semibold'
                  : 'text-slate-500 hover:text-slate-300'"
                @click="switchLocale(locale)"
              >
                {{ locale }}
              </button>
            </div>
            <!-- Sign in CTA -->
            <RouterLink
              to="/organizer/login"
              class="text-xs text-slate-400 hover:text-white border border-slate-700 hover:border-slate-500 rounded-lg px-3 py-1.5 transition-colors"
            >
              {{ t('nav.organizer_login') }}
            </RouterLink>
          </div>
        </div>
      </div>
    </header>

    <!-- Page content -->
    <div class="flex-1">
      <slot />
    </div>

    <!-- Minimal footer -->
    <footer class="border-t border-slate-800 py-6 text-center text-xs text-slate-600">
      {{ t('footer.copyright', { year: new Date().getFullYear() }) }}
    </footer>
  </div>
</template>
